import { render, staticRenderFns } from "./KD4Config.vue?vue&type=template&id=1d31d387&scoped=true"
import script from "./KD4Config.vue?vue&type=script&lang=js"
export * from "./KD4Config.vue?vue&type=script&lang=js"
import style0 from "./KD4Config.vue?vue&type=style&index=0&id=1d31d387&prod&lang=css"
import style1 from "./KD4Config.vue?vue&type=style&index=1&id=1d31d387&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d31d387",
  null
  
)

export default component.exports